import React from 'react';
import classNames from 'classnames';
import EditIcon from '@material-ui/icons/Edit';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import ContentParser from 'src/ui/library/ContentParser';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

export default function CasesFormDetailPres({
  showModal,
  formDetails,
  isEditable,
  isActionBarHidden,
  onFormChange,
  onCancelModal,
  onConfirmModal,
  onCancel,
  onEdit,
  onSave,
  isCorpClientLineManager,
  isLoading,
}) {
  if (isLoading || !formDetails.case)
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  if (!formDetails.case.pageElements)
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );

  const formClass = classNames({
    'cases-form-detail': true,
    editmode: isEditable,
  });

  const wrapperFormDivClass = classNames({
    'detail-body-inner': true,
  });

  const numberOfColumns = isEditable ? 4 : 3;
  return (
    <React.Fragment>
      {showModal && (
        <ConfirmDialog
          open
          title={intl.get('cases.details.messages.cancelTitle')}
          cancelText={intl.get('cases.details.buttons.cancelEdit')}
          confirmText={intl.get('cases.details.buttons.continueEdit')}
          onCancel={onCancelModal}
          onConfirm={onConfirmModal}>
          {intl.get('cases.details.messages.confirmMessage')}
        </ConfirmDialog>
      )}
      <div className={wrapperFormDivClass}>
        <div className={fnShowNewDashboard() ? 'new-dashboard-case-editable' : ''}>
          <section className={formClass}>
            {!isCorpClientLineManager ? (
              <div className="form-parser">
                <ContentParser
                  key={isEditable}
                  readOnly={!isEditable}
                  data={formDetails.case}
                  numberOfColumns={numberOfColumns}
                  showLabels={false}
                  debug={false}
                  onChange={onFormChange}
                />
              </div>
            ) : null}
          </section>
        </div>
      </div>
      {!isActionBarHidden && !isCorpClientLineManager ? (
        <section className={fnShowNewDashboard() ? 'cases-actions formdetail new-dashboard-case-actions' : 'cases-actions formdetail'}>
          {isEditable ? (
            <div className="button-wrapper">
              <Button styleType="secondary" onClick={onCancel} className="action-button">
                {intl.get('cases.details.buttons.cancel')}
              </Button>
              <Button className="action-button" onClick={onSave}>
                {intl.get('cases.details.buttons.save')}
              </Button>
            </div>
          ) : (
            <a className="edit-link" onClick={onEdit}>
              <EditIcon className="edit-icon" /> <span className="edit-text">{intl.get('cases.details.buttons.editDetails')}</span>
            </a>
          )}
        </section>
      ) : null}
    </React.Fragment>
  );
}
